import { createBrowserHistory } from "history";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../../../../config/farmDetails";
import { harvestYearDetail } from "../../../../../../config/harvestYearDetail";
import { createLoadIndicatorAction } from "../../../../../../modules/loadnoindicator/action";
import "../../../../../../style";
import { validForm } from "../../../../../FormElement/FormValidator";
import LoadIndicatorForm from "./LoadIndicatorForm";

const history = createBrowserHistory();

class CreateField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadInfo: {
        fieldGroupId: localStorage.getItem("currentFieldGrpId"),
        type: "",
        code: "",
        harvestYear: harvestYearDetail().name,
        farmId: userFarmDetail().id || this.props.selectedMainFarm
      },
      formErrors: {
        type: "",
        code: ""
      },
      isValid: true,
      successMessage: "",
      errorMessage: {},
      edited: false
    };
  }

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "code" || name === "type") {
      if (value.match(/^(\w|\ |\-){0,51}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          loadInfo: {
            ...prevState.loadInfo,
            [name]: value
          }
        };
      },
      () => {
        const { loadInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, loadInfo)
        });
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { loadInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, loadInfo)
        });
      }
    );
  };

  onCancel = e => {
    e.preventDefault();
    history.goBack();
  };

  createLoadIndicator = e => {
    e.preventDefault();
    const { loadInfo } = this.state;
    loadInfo.harvestYear = harvestYearDetail().name;
    loadInfo.farmId = userFarmDetail().id || this.props.selectedMainFarm;
    this.setState({ isValid: true, edited: false });
    this.props.createLoadIndicatorAction(loadInfo);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.loadCreated && nextProps.loadCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  render() {
    const { successMessage, loadInfo, isValid, edited } = this.state;
    if (successMessage) {
      return (
        <Redirect to="/farmsetup/farminformation/field-groups/indicators" />
      );
    }
    return (
      <LoadIndicatorForm
        buttonLabel="Add new load indicator"
        formLabel="Set up your load indicator"
        loadInfo={loadInfo}
        handleChange={this.handleChange}
        handleError={this.handleError}
        createLoadIndicator={this.createLoadIndicator}
        isValid={isValid}
        onCancel={this.onCancel}
        edited={edited}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    loadCreated: state.loadReducer.loadCreated,
    selectedMainFarm: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createLoadIndicatorAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateField);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/LoadNumberIndicators/CreateLoadNoIndicator.js